'use client';

import { createContext } from 'react';

export type Theme = 'dark' | 'light' | 'system';

export type ThemeProviderState = {
  theme: Theme;
  resolvedTheme: 'dark' | 'light';
};

const initialState: ThemeProviderState = {
  theme: 'system',
  resolvedTheme: 'light',
};

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState);
